export default "__VITE_ASSET__COGxpI2t__"